<template>
  <div
    class="filter-checkbox-wrapper"
    :class="{ disabled }"
    @click="
      $emit('click', $event);
      $emit('input', !value);
    "
  >
    <div class="filter-checkbox-indicator" :class="{ checked: value }">
      <inline-svg v-if="value" :src="require('../../../assets/img/icons/check_mark.svg')"></inline-svg>
    </div>
    <div class="checkbox-label font-sans">{{ label }}</div>

    <inline-svg
      v-if="tooltip"
      v-tooltip="tooltip"
      class="tooltip-icon"
      :src="require('@/assets/img/icons/info_icon.svg')"
    ></inline-svg>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/base/_vars.scss";
.filter-checkbox-wrapper {
  margin: 0 5px 15px 5px;
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.tooltip-icon{
  outline: none;
}

.filter-checkbox-indicator {
  border: 2px solid #757575;
  height: 24px;
  width: 24px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all $defaultTransitionTime $defaultTransitionType;

  &.checked {
    background: black;
    border-color: black;
  }
}
.checkbox-label {
  margin-left: 10px;
}
</style>

<script>
import InlineSvg from "vue-inline-svg";

export default {
  components: { InlineSvg },
  props: ["value", "label", "disabled", "tooltip"],
};
</script>
